/*
 * 90 Minutes — Home Hero sliding carousel
 * Slides the [data-hero-track] left (right-to-left advance) inside [data-hero-carousel].
 * Autoplay from data-autoplay (seconds); prev/next arrows; dots.
 */
(function () {
  function initHero(root) {
    var track = root.querySelector('[data-hero-track]');
    var slides = root.querySelectorAll('[data-hero-slide]');
    if (!track || slides.length < 2) return;
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var current = 0;
    var timer = null;
    var delay = (parseFloat(root.getAttribute('data-autoplay')) || 0) * 1000;

    function show(i) {
      current = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('active', d === current);
      }
    }
    function start() {
      if (delay > 0) { stop(); timer = setInterval(function () { show(current + 1); }, delay); }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
    if (next) next.addEventListener('click', function () { show(current + 1); start(); });
    for (var d = 0; d < dots.length; d++) {
      (function (idx) { dots[idx].addEventListener('click', function () { show(idx); start(); }); })(d);
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    show(0);
    start();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-hero-carousel]');
    for (var i = 0; i < roots.length; i++) initHero(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
